import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const subscribeToTrackingUpdatesByCode = unaryRpc({
  name: "subscribeToTrackingUpdatesByCode",
  input: z.object({
    trackingCode: z.string().trim().min(1).max(128),
    phoneNumber: z.string().trim().min(1).max(64),
    marketingConsent: z.boolean(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
});
